<template>
  <div class="container footer-slider">
    <h3>{{$t('home.Instruments.title')}}</h3>
    <el-carousel :interval="500000" arrow="never" indicator-position="none" height="450px">
      <el-carousel-item key="0">
        <div class="flex" style="gap: 48px; justify-content: space-between; align-items: center; padding: 0 40px;">
          <div class="left flex flex-column" style="gap:12px;">
            <!-- <p>{{$t('home.Instruments.advan01')}}</p>
            <p>{{$t('home.Instruments.advan02')}}</p>
            <p>{{$t('home.Instruments.advan03')}}</p>
            <p>{{$t('home.Instruments.advan04')}}</p>
            <p>{{$t('home.Instruments.advan05')}}</p>
            <p>{{$t('home.Instruments.advan06')}}</p>
            <p>{{$t('home.Instruments.advan07')}}</p>
            <p>{{$t('home.Instruments.advan08')}}</p>
            <p>{{$t('home.Instruments.advan09')}}</p>
            <p>{{$t('home.Instruments.advan10')}}</p> -->
            <p>{{$t('home.Instruments.advan11')}}</p>
            <p>{{$t('home.Instruments.advan12')}}</p>
            <p>{{$t('home.Instruments.advan13')}}</p>
            <p>{{$t('home.Instruments.advan14')}}</p>
          </div>
          <img width="462" height="372" src="@/assets/image/home/InstrumentsImg@2x.png" alt="" />
        </div>
      </el-carousel-item>

      <!-- <el-carousel-item key="1">
        <div class="flex">
          <div class="left flex flex-column">
            <h4>{{$t('home.tradingPlatform.service')}} </h4>
            <p>{{$t('home.tradingPlatform.describe')}}</p>
            <span><img src="../../assets/image/home/icon-download.png" alt="" srcset="" />{{$t('home.tradingPlatform.download')}}</span>
            <div>
              <button class="btn btn-primary" @click="$open('pc')">{{$t('home.tradingPlatform.pc')}}</button>
              <button class="btn btn-primary" @click="$open('mac')">{{$t('home.tradingPlatform.MAC')}}</button>
              <button class="btn" @click="$open('android')" style="margin-right: 5px">{{$t('home.tradingPlatform.android')}}</button>
              <button class="btn" @click="$open('iOS')">{{$t('home.tradingPlatform.ios')}}</button>
            </div>
          </div>
          <div class="right">
          </div>
        </div>

      </el-carousel-item>
      <el-carousel-item key="2">
        <div class="flex">
          <div class="left flex flex-column">
            <h4>{{$t('home.tradingPlatform.service5')}}</h4>
            <p>{{$t('home.tradingPlatform.describe')}}</p>
            <span><img src="../../assets/image/home/icon-download.png" alt="" srcset="" />{{$t('home.tradingPlatform.download')}}</span>
            <div>
              <button class="btn btn-primary" @click="$open('login5')">{{$t('home.tradingPlatform.pc')}}</button>
              <button class="btn btn-primary" @click="$open('login5')">{{$t('home.tradingPlatform.MAC')}}</button>
              <button class="btn" @click="$open('login5')" style="margin-right: 5px">{{$t('home.tradingPlatform.android')}}</button>
              <button class="btn" @click="$open('login5')">{{$t('home.tradingPlatform.ios')}}</button>
            </div>
          </div>
          <div class="right right5" style="order: -1; margin-left: 0; margin-right: 64px">
          </div>
        </div>
      </el-carousel-item> -->
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'footer-slider',
}
</script>

<style scoped lang="scss">
.footer-slider {
  padding: 80px 0 0;
  h3 {
    margin-bottom: 70px;
    color: #000;
    font-size: 35px;
    text-align: center;
  }
  .left {
    flex: 1;
    align-items: flex-start;
    h4 {
      color: #0D73D6;
      font-size: 38px;
      margin-top: 16px;
    }
    p {
      // font-size: 16px;
      font-size: 20px;
      color: #000;
      opacity: 0.6;
      // line-height: 22px;
      line-height: 30px;
      margin: 0;
      position: relative;
      padding-left: 20px;
      &::before {
        content: '';
        position: absolute;
        width: 5px;
        height: 5px;
        background: rgba(0, 0, 0, 0.6);
        // top: 8px;
        top: 12px;
        left: 8px;
        border-radius: 50%;
      }
    }
    span {
      font-size: 14px;
      color: #0009;
      margin-bottom: 22px;
      img {
        vertical-align: middle;
        margin-right: 8px;
      }
    }
    .btn {
      color: #0D73D6;
      min-width: 100px;
    }
    .btn-primary {
      margin-right: 5px;
      color: #fff;
    }
  }
  .right {
    width: 467px;
    height: 278px;
    margin-left: 64px;
    @include bg-image('../../assets/image/home/footer-slider');
  }

  .right5 {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    @include bg-image('../../assets/image/platform/device-MT5');
  }

  /deep/ .el-carousel__indicator--horizontal {
    padding: 12px 7px;
    .el-carousel__button {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: rgba(13, 115, 214, 1);
    }
  }

  //@include bg-image('../../assets/image/home/footer-slider-bg');
}
</style>
